import { SVGPropsIcon } from 'src/types';

export const ProviderSearchIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <mask
        id="mask0_15088_7674"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <path d="M0 1.90735e-06H24V24H0V1.90735e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_15088_7674)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 24H18.2812V9.89063H0V24ZM1.40625 22.5938V11.2969H16.875V22.5938H1.40625Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.625 23.2969H7.03125V21.1406H11.25V23.2969H12.6562V19.7344H5.625V23.2969Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1875 7.78125V13.4062H22.5937V7.78125H21.1875Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7812 6.375C19.7812 7.54001 20.7257 8.48438 21.8906 8.48438C23.0556 8.48438 24 7.54001 24 6.375C24 5.21005 23.0556 4.26562 21.8906 4.26562C20.7257 4.26562 19.7812 5.21005 19.7812 6.375ZM21.8906 7.07813C21.5023 7.07813 21.1875 6.76333 21.1875 6.375C21.1875 5.9867 21.5023 5.67188 21.8906 5.67188C22.2789 5.67188 22.5938 5.9867 22.5938 6.375C22.5938 6.76333 22.2789 7.07813 21.8906 7.07813Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5781 16.9219H0.703125V18.3281H17.5781V16.9219Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.03125 17.625V10.5938H5.625V17.625H7.03125Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6562 17.625V10.5938H11.25V17.625H12.6562Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.625 8.48438H12.6562V4.26562H5.625V8.48438ZM7.03125 7.07813V5.67188H11.25V7.07813H7.03125Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.2969H18.2812V3.16252L17.998 2.95165L17.5781 3.51562C17.998 2.95165 17.9978 2.95152 17.9977 2.95137L17.9972 2.95103L17.996 2.95016L17.9926 2.94766C17.9899 2.94565 17.9863 2.94298 17.9817 2.93965C17.9726 2.93301 17.9599 2.92377 17.9436 2.91211C17.911 2.8888 17.8641 2.85579 17.8038 2.81449C17.6831 2.7319 17.5081 2.616 17.2845 2.47793C16.8378 2.20205 16.1947 1.83623 15.401 1.47071C13.8196 0.742504 11.6068 9.53674e-07 9.14062 9.53674e-07C6.67446 9.53674e-07 4.46165 0.742504 2.8803 1.47071C2.08655 1.83623 1.44347 2.20205 0.996732 2.47793C0.773161 2.616 0.598185 2.7319 0.47749 2.81449C0.417125 2.85579 0.370288 2.8888 0.337687 2.91211C0.321384 2.92377 0.308637 2.93301 0.299532 2.93965C0.294979 2.94298 0.291337 2.94565 0.288616 2.94766L0.285227 2.95016L0.284053 2.95103L0.283597 2.95137C0.283405 2.95152 0.283228 2.95165 0.703125 3.51562L0.283228 2.95165L0 3.16252V11.2969ZM1.40625 3.88458C1.49619 3.82516 1.60647 3.75418 1.73563 3.67441C2.14281 3.42295 2.73536 3.08564 3.4685 2.74804C4.94091 2.07 6.94685 1.40625 9.14062 1.40625C11.3344 1.40625 13.3403 2.07 14.8127 2.74804C15.5459 3.08564 16.1384 3.42295 16.5456 3.67441C16.6748 3.75418 16.7851 3.82516 16.875 3.88458V9.89063H1.40625V3.88458Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4687 15.5156V12.7031H14.0625V15.5156H15.4687Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.84375 15.5156V12.7031H8.4375V15.5156H9.84375Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.21875 15.5156V12.7031H2.8125V15.5156H4.21875Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.875 16.9219H20.4844C21.6493 16.9219 22.5937 15.9775 22.5937 14.8125V12.7031H16.875V16.9219ZM18.2812 15.5156V14.1094H21.1875V14.8125C21.1875 15.2008 20.8727 15.5156 20.4844 15.5156H18.2812Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
